import type { App } from "@upsquad/server";
import type { PresignBatchUploadPayload, PresignUploadPayload } from "@upsquad/shared";
import type { EdenCall } from "@/src/common/lib/eden-base-query";
import { baseApi } from "@/src/common/services/base-api";

type PresignUploadResponse = App["~Routes"]["upload"]["presign"]["post"]["response"]["200"];
type PresignBatchResponse = App["~Routes"]["upload"]["presign-batch"]["post"]["response"]["200"];

export const uploadApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		presignUpload: builder.mutation<PresignUploadResponse, PresignUploadPayload>({
			query:
				(payload): EdenCall<PresignUploadResponse> =>
				(client) =>
					client.upload.presign.post(payload),
		}),
		presignBatchUpload: builder.mutation<PresignBatchResponse, PresignBatchUploadPayload>({
			query:
				(payload): EdenCall<PresignBatchResponse> =>
				(client) =>
					client.upload["presign-batch"].post(payload),
		}),
	}),
});

export const { usePresignUploadMutation, usePresignBatchUploadMutation } = uploadApi;
